import Vue from 'vue'
import { API_URL } from '../../api'
import MediaFilesFilter from '../../filters/MediaFilesFilter';
const state = {
    mediaCreate: {
        createdMedia: null,
        creatingMedia: false,
        createMediaStatus: null
    },
    mediaUpdate: {
        updatedMedia: null,
        updatingMedia: false,
        updateMediaStatus: null
    },
    mediaDelete: {
        deletingMedia: false,
        deleteMediaStatus: null
    },
    mediaSearch: {
        mediaFilesCount: null,
        mediaFiles: [],
        searchingMediaFiles: false,
        searchMediaStatus: null
    },
}
const mutations = {
    ['SET_MEDIA_FILE_CREATE'](state, change) {
        state.mediaCreate = { ...state.mediaCreate, ...change };
    },
    ['SET_MEDIA_FILE_UPDATE'](state, change) {
        state.mediaUpdate = { ...state.mediaUpdate, ...change };
    },
    ['SET_MEDIA_FILE_DELETE'](state, change) {
        state.mediaDelete = { ...state.mediaDelete, ...change };
    },
    ['SET_MEDIA_FILE_SEARCH'](state, change) {
        state.mediaSearch = { ...state.mediaSearch, ...change };
    }
}
const actions = {
    createMedia: ({ commit }, payload) => {
        let data = new FormData()
        data.append('file', payload.file)
        commit('SET_MEDIA_FILE_CREATE', { createMediaStatus: null, createdMedia: null, creatingMedia: true })
        return Vue.http.post(API_URL + '/media-files/create', payload, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(response => {
            commit('SET_MEDIA_FILE_CREATE', { createMediaStatus: 'success', createdMedia: response.body.results.media });
        }).catch(response => {
            commit('SET_MEDIA_FILE_CREATE', { createMediaStatus: 'failed' });
        }).finally(() => {
            commit('SET_MEDIA_FILE_CREATE', { creatingMedia: false });
        });
    },
    updateMedia: ({ commit }, payload) => {
        commit('SET_MEDIA_FILE_UPDATE', { updateMediaStatus: null, updatedMedia: null, updatingMedia: true })
        return Vue.http.post(API_URL + '/media-files/update/' + payload.id, payload)
            .then(response => {
                commit('SET_MEDIA_FILE_UPDATE', { updateMediaStatus: 'success', updatedMedia: response.body.results.media });
            })
            .catch(response => {
                commit('SET_MEDIA_FILE_UPDATE', { updateMediaStatus: 'failed' });
            })
            .finally(() => {
                commit('SET_MEDIA_FILE_UPDATE', { updatingMedia: false });
            })
    },
    deleteMedia: ({ commit }, id) => {
        commit('SET_MEDIA_FILE_DELETE', { deleteMediaStatus: null, deletedMedia: null, deletingMedia: true })
        return Vue.http.delete(API_URL + '/media-files/delete/' + id).then(response => {
            commit('SET_MEDIA_FILE_DELETE', { deleteMediaStatus: 'success' });
        }).catch(response => {
            commit('SET_MEDIA_FILE_DELETE', { deleteMediaStatus: 'failed' });
        }).finally(() => {
            commit('SET_MEDIA_FILE_DELETE', { deletingMedia: false });
        })
    },
    searchMediaFiles: ({ commit }, payload = { filter: MediaFilesFilter(), resultMode: 'default' }) => {
        commit('SET_MEDIA_FILE_SEARCH', { searchMediaStatus: null, searchMedia: null, searchingMediaFiles: true })
        let filerJson = JSON.stringify(payload.filter);
        switch (payload.resultMode) {
            case 'count': payload.resultMode = 1; break;
            case 'paginated': payload.resultMode = 2; break;
            case 'paginatedPersist': payload.resultMode = 21; break;
            default: payload.resultMode = 0; break;
        }
        var params = '?query=' + encodeURIComponent(filerJson) + '&result_mode=' + payload.resultMode;
        return Vue.http.get(API_URL + '/media-files' + params).then(response => {
            commit('SET_MEDIA_FILE_SEARCH', { searchMediaStatus: 'success', mediaFiles: response.body.results.mediaFiles });
        }).catch(response => {
            commit('SET_MEDIA_FILE_SEARCH', { searchMediaStatus: 'failed' });
        }).finally(() => {
            commit('SET_MEDIA_FILE_SEARCH', { searchingMediaFiles: false });
        })
    },
}
export default {
    state, mutations, actions
} 



// WEBPACK FOOTER //
// ./resources/js/store/modules/mediaStore.js